import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { getExamSchedule } from "../../../utils/cairoTime";

const useExamSchedule = (exam) => {
  const [now, setNow] = useState(() => dayjs());

  useEffect(() => {
    const id = setInterval(() => setNow(dayjs()), 1000);
    return () => clearInterval(id);
  }, []);

  return getExamSchedule(exam, now);
};

export default useExamSchedule;
